import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import GridTable from '../../components/GridTable';
import Layout from '../../components/Layout';
import { MODULES } from '../../utils/constants';
import { useReviewStore } from '../../services/reviews';
import { getColumns } from './constants';
import { ReviewSource } from '../../types/reviews';

const Reviews = () => {
  const { data, totalPages, total, currentPage, rows, filters, isLoading, fetchGrid, setFilters, onPageChange } = useReviewStore();
  const [search, setSearch] = React.useState(filters.search ?? '');

  React.useEffect(() => { fetchGrid(); }, []);

  return (
    <Layout appBarTitle="Reviews">
      <Box sx={{ mb: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
          <TextField
            size="small"
            label="Search reviews"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') setFilters({ ...filters, search: search.trim() || undefined });
            }}
          />
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <InputLabel>Source</InputLabel>
            <Select
              label="Source"
              value={filters.source ?? ''}
              onChange={(event) => setFilters({ ...filters, source: (event.target.value || undefined) as ReviewSource | undefined })}
            >
              <MenuItem value="">All sources</MenuItem>
              <MenuItem value="booking">Booking</MenuItem>
              <MenuItem value="externalBooking">External booking</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Rating</InputLabel>
            <Select
              label="Rating"
              value={filters.rating ?? ''}
              onChange={(event) => setFilters({ ...filters, rating: event.target.value ? Number(event.target.value) : undefined })}
            >
              <MenuItem value="">All</MenuItem>
              {[5, 4, 3, 2, 1].map((rating) => <MenuItem key={rating} value={rating}>{rating} stars</MenuItem>)}
            </Select>
          </FormControl>
        </Stack>
      </Box>
      <Layout.Body component={GridTable} props={{
        data,
        columns: getColumns(currentPage, rows),
        currentPage,
        totalPages,
        total,
        loading: isLoading,
        onPageChange,
        module: MODULES.REVIEW,
        rows,
        hideAction: true,
      }} />
    </Layout>
  );
};

export default Reviews;
